export const UTXOAPISchemaMethods = [
    'getBalance',
    'getTransactions',
    'getUTXOs',
    'getTransactionFee',
];
//# sourceMappingURL=types.js.map